import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  Container,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SectionHeading from "../Shared/SectionHeading";

const policySections = [
  {
    title: "1. Information We Collect",
    content:
      "We may collect personal identification details such as name, email, and phone number, along with website usage information and cookie-based analytics to improve the browsing experience.",
  },
  {
    title: "2. How We Use Your Information",
    content:
      "Information is used to respond to inquiries, process consultation requests, improve services, and communicate relevant updates when you opt in.",
  },
  {
    title: "3. Data Security",
    content:
      "We apply appropriate security safeguards. While we follow good practices, internet-based data transmission can never be guaranteed as absolutely secure.",
  },
  {
    title: "4. Sharing Your Information",
    content:
      "We do not sell or rent personal information. Data may be shared with trusted service providers only when necessary to operate our services or when required by law.",
  },
  {
    title: "5. Third-Party Links",
    content:
      "Our website may include links to third-party websites. We are not responsible for the privacy practices of external sites.",
  },
  {
    title: "6. Your Rights and Choices",
    content:
      "You may request access, corrections, or deletion of personal data (subject to legal obligations), and may opt out of marketing communication at any time.",
  },
  {
    title: "7. Children’s Privacy",
    content:
      "We do not knowingly collect information from children under 13. If identified, such data will be removed promptly.",
  },
  {
    title: "8. Policy Updates",
    content:
      "This policy may be revised periodically. Any changes will be reflected on this page along with updated effective details.",
  },
];

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: { xs: 4.4, md: 5.5 },
        background: "linear-gradient(180deg, #f8f3ee 0%, #fcfaf7 100%)",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mb: 1.3,
          }}
        >
          <Button
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            onClick={() => navigate("/")}
            sx={{
              px: 2.2,
              py: 0.85,
              borderRadius: "999px",
              textTransform: "none",
              borderColor: "rgba(128,51,65,0.45)",
              color: "#672936",
              fontFamily: '"Manrope", sans-serif',
              fontWeight: 700,
              "&:hover": {
                borderColor: "#803341",
                backgroundColor: "rgba(128,51,65,0.07)",
              },
            }}
          >
            Back to Home
          </Button>
        </Box>

        <Box
          sx={{
            borderRadius: { xs: "22px", md: "30px" },
            p: { xs: 1.4, sm: 1.8, md: 2.3 },
            background:
              "linear-gradient(152deg, rgba(255,255,255,0.86), rgba(255,247,243,0.72))",
            border: "1px solid rgba(128,51,65,0.13)",
            boxShadow: "0 16px 38px rgba(20,8,10,0.1)",
          }}
        >
          <SectionHeading
            eyebrow="Legal"
            title="Privacy Policy"
            subtitle="Your trust matters to us. This policy outlines what information we collect, how we use it, and how we protect it."
            align="left"
            titleAs="h1"
          />

          <Stack spacing={1.1}>
            {policySections.map((section) => (
              <Box
                key={section.title}
                sx={{
                  borderRadius: "14px",
                  p: { xs: 1.15, md: 1.4 },
                  border: "1px solid rgba(128,51,65,0.14)",
                  background: "rgba(255,255,255,0.68)",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: '"Manrope", sans-serif',
                    fontWeight: 700,
                    color: "#3a1b22",
                    fontSize: { xs: "0.95rem", md: "1rem" },
                    mb: 0.45,
                  }}
                >
                  {section.title}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: '"Manrope", sans-serif',
                    color: "rgba(58,27,34,0.82)",
                    fontSize: { xs: "0.88rem", md: "0.93rem" },
                    lineHeight: 1.7,
                  }}
                >
                  {section.content}
                </Typography>
              </Box>
            ))}
          </Stack>

          <Box
            sx={{
              mt: 1.2,
              borderRadius: "14px",
              p: { xs: 1.15, md: 1.4 },
              border: "1px solid rgba(128,51,65,0.14)",
              background: "rgba(255,255,255,0.68)",
            }}
          >
            <Typography
              sx={{
                fontFamily: '"Manrope", sans-serif',
                fontWeight: 700,
                color: "#3a1b22",
                fontSize: { xs: "0.95rem", md: "1rem" },
                mb: 0.45,
              }}
            >
              9. Contact Us
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Manrope", sans-serif',
                color: "rgba(58,27,34,0.82)",
                fontSize: { xs: "0.88rem", md: "0.93rem" },
                lineHeight: 1.74,
              }}
            >
              Vista Fusion Studio
              <br />
              Email:{" "}
              <Link href="mailto:contact@vistafusionstudio.com" underline="hover">
                contact@vistafusionstudio.com
              </Link>
              <br />
              Phone: +91 90303 56464
              <br />
              Website:{" "}
              <Link
                href="https://www.vistafusionstudio.com"
                target="_blank"
                rel="noopener"
                underline="hover"
              >
                www.vistafusionstudio.com
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
